import * as Yup from 'yup';

const validationSchema = Yup.object({
  salePrice: Yup.number().nullable().min(0).required('validation.fieldRequired'),
  costPrice: Yup.number().nullable().min(0).required('validation.fieldRequired'),
  name: Yup.string().required('validation.fieldRequired').max(50, 'validation.lessThan50Chars'),
});

export default validationSchema;
